export default __webpack_public_path__ + "static/media/Y9.3134d53f.jpg";